export function buildSelectionRangeParamList(all: string[], anchor: string, label: string): string[] | null {
  const idxA = all.indexOf(anchor);
  const idxB = all.indexOf(label);
  if (idxA === -1 || idxB === -1) {
    return [label];
  }

  const [start, end] = idxA < idxB ? [idxA, idxB] : [idxB, idxA];
  return all.slice(start, end + 1);
}

export function buildCtrlToggledParamList(
  all: string[],
  currentExplicit: string[] | null,
  label: string,
): string[] | null {
  const current = currentExplicit ?? all;
  const next = current.includes(label) ? current.filter(value => value !== label) : [...current, label];
  return next.length === 0 ? null : next;
}

export function buildAddedSelectionParamList(
  all: string[],
  currentExplicit: string[] | null,
  value: string,
): string[] | null {
  const current = currentExplicit ?? all;
  if (current.includes(value)) {
    return current;
  }

  return [...current, value];
}
